import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { QuotationInfoContext } from '../../contexts';

import { Confirmation } from '../../../../../../../shared/components';

export const ConfirmIssueQuotation = () => {
  const navigate = useNavigate();

  const { quotationInfo } = useContext(QuotationInfoContext);

  const onPressConfirm = () => navigate('/produccion/listado-de-polizas');

  return (
    <Confirmation
      title={`Cotización ${quotationInfo?.token} enviada correctamente`}
      description={`Se ha enviado un correo electrónico con la información de la propuesta${' '}
        ${quotationInfo?.proposalNumber} a la casilla del productor.`}
      onPressConfirm={onPressConfirm}
    />
  );
};
